import React, { useEffect, useState } from 'react'

import { Source } from 'types/GlobalSource'

import Button from 'components_new/atoms/Button'
import TextField from 'components_new/atoms/TextField'

import SelectSearch from 'components_new/molecules/SelectSearch'
import SimpleDialog from 'components_new/molecules/SimpleDialog'

import { AUTH_OPTIONS } from 'utils/sources'

export type TAuthValues = {
  connection_id: string
  field: string
  location: string
  value: string | undefined
}

interface EditAuthDialogProps {
  onClose: () => void
  onSubmit: (params: { auth_params: TAuthValues[] }) => void
  open: boolean
  source: Source
}

const getInitialValues = (source: Source): TAuthValues | null => {
  const authParam = source.included.auth_params[0]

  if (!authParam) {
    return null
  }

  return {
    connection_id: authParam.attributes.connection_id,
    field: authParam.attributes.field,
    location: authParam.attributes.location,
    // Write only — the current secret is never sent back to the portal.
    value: undefined
  }
}

const EditAuthDialog = (props: EditAuthDialogProps) => {
  const { onClose, onSubmit, open, source } = props

  const [values, setValues] = useState<TAuthValues | null>(() =>
    getInitialValues(source)
  )

  useEffect(() => {
    if (open) {
      setValues(getInitialValues(source))
    }
  }, [open, source])

  if (!values) {
    return null
  }

  const selectedLocation =
    AUTH_OPTIONS.find((item) => item.id === values.location) ?? null

  return (
    <SimpleDialog
      actions={
        <>
          <Button onClick={onClose} variant="text">
            Avbryt
          </Button>
          <Button
            onClick={() => {
              onSubmit({ auth_params: [values] })
              onClose()
            }}
          >
            Spara
          </Button>
        </>
      }
      onClose={onClose}
      open={open}
      title="Uppdatera autentisering"
    >
      <SelectSearch
        closeOnSelect={true}
        disableClearable={true}
        multiple={false}
        onChange={(location) => setValues({ ...values, location: location.id })}
        options={AUTH_OPTIONS}
        placeholder="Välj typ..."
        selected={selectedLocation}
        size="medium"
      />
      <TextField
        label="Fält"
        onChange={(event) =>
          setValues({ ...values, field: event.target.value })
        }
        value={values.field}
      />
      <TextField
        label="Värde"
        onChange={(event) =>
          setValues({ ...values, value: event.target.value })
        }
        value={values.value}
      />
    </SimpleDialog>
  )
}

export default EditAuthDialog
